import { render, staticRenderFns } from "./ArtikelTypeGroupComponent.vue?vue&type=template&id=6fec7ad2&"
import script from "./ArtikelTypeGroupComponent.vue?vue&type=script&lang=js&"
export * from "./ArtikelTypeGroupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports